import { Component, Input } from '@angular/core';
import { TextComponent } from './text.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'hk-icon-with-label',
  template: `
    <i [class.mr-2]="text || ref.innerHTML.trim()" [ngClass]="iconClass" class="text-xl"></i>
    <hk-text [ngClass]="textClass" class="text-sm">
      {{ text }}
      <span #ref><ng-content></ng-content></span>
    </hk-text>
  `,
  host: { class: 'flex flex-1 items-center justify-start' },
  imports: [TextComponent, NgClass],
  standalone: true,
})
export class IconWithLabelComponent {
  @Input() iconClass = '';
  @Input() text?: string;
  @Input() textClass = '';
}
